import React from "react";
import style from '../../assets/styles/linearColored.module.scss';
import { roleList } from '../../utils/utils';

export default function LinearColoredComponent({
  data,
  title,
  assignNum,
  ...props
}) {
  const getColor = (role) => {
    const index = assignNum[0].indexOf(role);
    if (index === -1) {
      return roleList[0];
    }
    return roleList[index % roleList.length];
  };

  return (
    <div className={style.colorLeniear}>
      {data?.[title?.name]?.map((role) => {
        const color = getColor(role);
        return (
          <span
            className={style.coloredConatiner}
            style={{ backgroundColor: color?.bgColor }}
          >
            <span
              className={style.coloredText}
              style={{ color: color?.textColor }}
            >
              {role}
            </span>
          </span>
        );
      })}
    </div>
  );
}
